import { render, staticRenderFns } from "./CategoryRelatedSlider.vue?vue&type=template&id=bd6f108c&scoped=true&"
import script from "./CategoryRelatedSlider.vue?vue&type=script&lang=js&"
export * from "./CategoryRelatedSlider.vue?vue&type=script&lang=js&"
import style0 from "./CategoryRelatedSlider.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./CategoryRelatedSlider.vue?vue&type=style&index=1&id=bd6f108c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6f108c",
  null
  
)

export default component.exports